// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"8a5a5b96","886":"e9ed049d","957":"ca9eed7b"}[chunkId] + ".chunk.js";
};